import { createSlice } from "@reduxjs/toolkit";

const selectedBuildingContactSlice = createSlice({
  name: "selectedBuildingContact",
  initialState: null,
  reducers: {
    setSelectedBuildingContact: (state, action) => {
      return action.payload;
    },
    clearSelectedBuildingContact: () => {
      return null;
    },
  },
});

export const { setSelectedBuildingContact, clearSelectedBuildingContact } =
  selectedBuildingContactSlice.actions;
export const selectedSelectedBuildingContacts = (state) =>
  state.selectedBuildingContact;

export default selectedBuildingContactSlice.reducer;
